
namespace RioERP.Reports {
    export class InvoiceBillingItemsReportColumns {
        static columnsKey = 'Reports.InvoiceBillingItemsReport';
    }
}